import axios from 'axios'

export default {
	getAll() {
		return axios.get(window.dtServerUrl + '/reports')
	},

	runReport(id, searchParams) {
		return axios.post(window.dtServerUrl + `/reports/${id}/run`, searchParams)
	},

	runReportAsCsv(id, searchParams) {
		return axios.post(window.dtServerUrl + `/reports/${id}/csv`, searchParams)
	},

	getStats(searchParams) {
		return axios.post(window.dtServerUrl + '/reports/stats', searchParams)
	},

	getSpend(searchParams) {
		return axios.post(window.dtServerUrl + '/reports/spend', searchParams)
	}
}
